export const DefaultItemWidthDesktop = 300 + 30;
export const DefaultItemWidthMobile = 250 + 25;
export const MaxCarouselWidth = 1460;
export const MaxItems = 4;